var map = {
	"./s_0.png": "afc9",
	"./s_1.png": "717a",
	"./s_10.png": "20d5",
	"./s_11.png": "b89b",
	"./s_2.png": "8550",
	"./s_3.png": "13b3",
	"./s_4.png": "9f64",
	"./s_5.png": "77c1",
	"./s_6.png": "65d2",
	"./s_7.png": "5a0f",
	"./s_8.png": "8603",
	"./s_9.png": "f915",
	"./s_9_1.png": "ba2a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c121";